import FileUploadIcon from "@mui/icons-material/FileUpload";
import BackupIcon from '@mui/icons-material/Backup';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import CategoryIcon from '@mui/icons-material/Category';
import BugReportIcon from '@mui/icons-material/BugReport';
import HandshakeIcon from '@mui/icons-material/Handshake';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import GroupIcon from '@mui/icons-material/Group';
import BlockIcon from '@mui/icons-material/Block';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import BarChartIcon from '@mui/icons-material/BarChart';
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'; // <-- Added icon here
import PaymentsIcon from '@mui/icons-material/Payments';
import AccountTreeIcon from "@mui/icons-material/AccountTree";

const icons = {
  FileUploadIcon,
  BackupIcon,
  Inventory2Icon,
  LocationCityIcon,
  CategoryIcon,
  BugReportIcon,
  HandshakeIcon,
  AccountBalanceIcon,
  GroupIcon,
  BlockIcon,
  HighlightOffIcon,
  CardGiftcardIcon,
  BarChartIcon,
  CrisisAlertIcon,
  NotificationsActiveIcon,
  PaymentsIcon,
  AccountTreeIcon
};

const upload = {
  id: 'dataUpload',
  title: 'Uploaders',
  type: 'group',
  icon: icons.BackupIcon,
  children: [
    {
      id: 'Mobilesalesupload',
      title: 'Mobile Sales',
      type: 'item',
      url: '/Mobile-Sales-Upload',
      icon: icons.FileUploadIcon
    },
    {
      id: 'BulkUpload',
      title: 'Product',
      type: 'item',
      url: '/Product-Upload',
      icon: icons.Inventory2Icon,
    },
    {
      id: 'citystateupload',
      title: 'City & State',
      type: 'item',
      url: '/UploadCity',
      icon: icons.LocationCityIcon,
    },
    {
      id: 'brandmodelupload',
      title: 'Brand & Model',
      type: 'item',
      url: '/UploadBrand',
      icon: icons.CategoryIcon,
    },
    {
      id: 'defectupload',
      title: 'Defect',
      type: 'item',
      url: '/UploadDefect',
      icon: icons.BugReportIcon,
    },
    {
      id: 'servicePartner',
      title: 'Service Partner',
      type: 'item',
      url: '/UploadServicePartner',
      icon: icons.HandshakeIcon,
    },
    {
      id: 'insurerUploader',
      title: 'Insurer',
      type: 'item',
      url: '/UploadInsurer',
      icon: icons.AccountBalanceIcon,
    },
    // {
    //   id: 'clientupload',
    //   title: 'Client',
    //   type: 'item',
    //   url: '/UploadClient',
    //   icon: icons.GroupIcon,
    // },
    {
      id: 'planWiseBERSlabs',
      title: 'Client & BER Slabs',
      type: 'item',
      url: '/planWiseBerSlabs',
      icon: icons.BarChartIcon,
    },
    {
      id: 'excessFeesCalAmountSlabs',
      title: 'Excess Fee Slabs',
      type: 'item',
      url: '/excessFeesCalAmountSlabs',
      icon: icons.PaymentsIcon,
    },
    {
      id: 'serviceTypeSubtypeUploader',
      title: 'Service Type & Sub-type',
      type: 'item',
      url: '/serviceTypeSubtypeUploader',
      icon: icons.AccountTreeIcon,
    },
    {
      id: 'cancellationreasonupload',
      title: 'Cancellation Reason',
      type: 'item',
      url: '/UploadCancellationReason',
      icon: icons.BlockIcon,
    },
    {
      id: 'rejectionreasonupload',
      title: 'Rejection Reason',
      type: 'item',
      url: '/UploadRejectionReason',
      icon: icons.HighlightOffIcon,
    },
    {
      id: 'plans',
      title: 'Plans & Benefits',
      type: 'item',
      url: '/plans-benefits',
      icon: icons.CardGiftcardIcon,
    },
    {
      id: 'critical-data-uploader',
      title: 'Critical',
      type: 'item',
      url: '/critical-uploader',
      icon: icons.CrisisAlertIcon,
    },
    {
      id: 'intimation-uploader',
      title: 'Intimation',
      type: 'item',
      url: '/missing-intimation-Uploader',
      icon: icons.NotificationsActiveIcon
    },
    {
      id: 'logistics-repair-uploader',
      title: 'Logistics & Repair',
      type: 'item',
      url: '/logistics-repair-uploader',
      icon: icons.NotificationsActiveIcon
    }
  ]
};

export default upload;
